var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.444 3.685a10.002 10.002 0 0112.315.945l.07.066V3.75a.75.75 0 111.499 0v2.329c0 .69-.56 1.248-1.249 1.249h-2.33a.75.75 0 110-1.5h1.094l-.099-.093A8.5 8.5 0 1020.5 12a.75.75 0 011.5 0A10 10 0 116.444 3.685z",
    fill: "currentColor"
  })));
}
SvgRefresh.displayName = 'Refresh';
export default SvgRefresh;